// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Toastr } from "@revvsales/components";

// Components Imports
import { BarChart, ChartHeader } from "../Charts";
import DashboardLoader from "../DashboardLoader";

// Actions Imports
import DashboardActions from "../../../actions/DashboardActions";

// Internal Imports
import { GlobalUtils } from "../../../utils";

// Destructuring
const { getDashboardSoldProducts } = DashboardActions;
const { handleApiErrMsg, numberForamting } = GlobalUtils;

class ProductPerformance extends Component {
  state = { showLoader: false };

  componentDidMount() {
    this._onInitData();
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onInitData = () => {
    const { apiConfigs: { userID, fromDate, toDate } = {} } = this.props;
    this._toggleLoader(true);
    this.props
      .getDashboardSoldProducts(userID, fromDate, toDate)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        console.error(
          `ProductPerformance(index.js) => _onInitData => ${error}`,
        );
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  // Chart Tool Text :: for showing the required data when hover on chart
  _getChartToolText = data => `
    <div class="chart-tooltext-wrapper">
      <div class="chart-tooltext-title">
        Product Details
      </div>
      <div class="chart-tooltext-row">
        <span class="chart-tooltext-row-title">Product Name </span> -  
        <span class="chart-tooltext-row-value"> ${data.product_name} </span>
      </div>
      <div class="chart-tooltext-row">
        <span class="chart-tooltext-row-title">No. of times sold </span> -  
        <span class="chart-tooltext-row-value"> ${data.frequency} </span>
      </div>
      <div class="chart-tooltext-row">
        <span class="chart-tooltext-row-title">Total Quantity </span> -
        <span class="chart-tooltext-row-value"> ${data.quantity || "0"} </span>
      </div>
      <div class="chart-tooltext-row">
        <span class="chart-tooltext-row-title">Product Value </span> -
        <span class="chart-tooltext-row-value primary-color">
        ${numberForamting(data.value, "$")} 
        </span>
      <div>
      <div class="chart-tooltext-row">
        <span class="chart-tooltext-row-title"> Avg Discount </span> -
        <span class="chart-tooltext-row-value high-danger-color">
        ${numberForamting(data.avg_discount, "$")}  
        </span>
      </div>
    </div>
  `;

  // Chart Data :: getting the chart data in a valid format
  _getChartData = soldProducts => {
    const chartData = [];
    if (soldProducts) {
      soldProducts.forEach(el => {
        chartData.push({
          label: el.product_name,
          value: el.frequency,
          tooltext: this._getChartToolText(el),
        });
      });
    }
    return chartData;
  };

  _decideChartHeader = showHeader => {
    if (showHeader) {
      return (
        <ChartHeader
          title="Product Performance"
          dateTitle="Jan 01, 2019 July 01, 2019"
        />
      );
    }
    return null;
  };

  _decideView = () => {
    const { showHeader, soldProducts, chartWidth, chartHeight } = this.props;
    if (this.state.showLoader) {
      return <DashboardLoader message="loading sold products" />;
    }

    // Make chart configs
    const chartConfigs = {
      data: this._getChartData(soldProducts),
      chart: {
        captionAlignment: "left",
        toolTipPadding: "10",
      },
      width: chartWidth,
      height: chartHeight,
    };

    return (
      <Fragment>
        {this._decideChartHeader(showHeader)}
        <BarChart configs={chartConfigs} />
      </Fragment>
    );
  };

  render() {
    return <Fragment>{this._decideView()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { soldProducts } = state.DashboardStore;
  return {
    soldProducts,
  };
};

const mapDispatchToProps = {
  getDashboardSoldProducts: (userID, fromDate, toDate) =>
    getDashboardSoldProducts(userID, fromDate, toDate),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductPerformance);



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/ProductPerformance/index.js